import { CALL_FORWARDING_STATE_KEY, ICallForwardingState } from './reducer';

export const getCallForwardingData = (state: any) => state[CALL_FORWARDING_STATE_KEY]?.data || [];
export const getCallForwardingTotal = (state: any) => state[CALL_FORWARDING_STATE_KEY]?.total || 0;
export const getCallForwardingLoading = (state: any) => state[CALL_FORWARDING_STATE_KEY]?.loading || false;
export const getCallForwardingExportLoading = (state: any) => state[CALL_FORWARDING_STATE_KEY]?.exportLoading || false;
export const getCallForwardingCancelLoading = (state: any) => state[CALL_FORWARDING_STATE_KEY]?.cancelLoading || false;
export const getCallForwardingSearch = (state: any) => state[CALL_FORWARDING_STATE_KEY]?.search || {};
export const getCallForwardingError = (state: any) => state[CALL_FORWARDING_STATE_KEY]?.error || null;
